import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { listInquirySearchConditionItemNameConfig } from './ListInquirySearchCondition.name';

enum ListInquirySearchCondition {
  specificSearch = '1',
  detailSearch = '2',
}

const listInquirySearchConditionItemMap = new Map([
  ['1', listInquirySearchConditionItemNameConfig.specificSearch],
  ['2', listInquirySearchConditionItemNameConfig.detailSearch],
]);

const rawValueToListInquirySearchCondition = rawValueToEnumWithDefault(
  listInquirySearchConditionItemMap,
  ListInquirySearchCondition.specificSearch,
);

const listInquirySearchConditionToDisplay = enumToNameWithDefault(
  ListInquirySearchCondition,
  listInquirySearchConditionItemNameConfig,
);

const listInquirySearchConditionToDisplayWithPrefix = enumToNameWithDefault(
  ListInquirySearchCondition,
  listInquirySearchConditionItemNameConfig,
  true,
);

export {
  ListInquirySearchCondition,
  listInquirySearchConditionToDisplay,
  listInquirySearchConditionToDisplayWithPrefix,
  rawValueToListInquirySearchCondition,
};
